import { Observable } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UrlService } from "../../../../../environments/urlService";
import { IS_SPINNER_ACTIVE } from "../../../../util/interceptors";
import { FRONT_URLS } from "../../../../util/common/url-parts";

@Injectable({
  providedIn: 'root',
})
export class TermsAndConditionsService {
  private readonly url: string;
  private http = inject(HttpClient);
  private urlService = inject(UrlService);

  constructor() {
    this.url = this.urlService.getModelsUrl() + FRONT_URLS.TERMS_AND_CONDITIONS;
  }

  setAgreement(isTermsAndConditionAccepted: boolean): Observable<void> {
    return this.http.post<void>(
      this.url, isTermsAndConditionAccepted,
      {
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true,
      });
  }
}
